import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Editor, Toolbar } from "ngx-editor";

import { BreadcrumbService } from 'src/app/core/framework/breadcrumb.service';
import { HtmlEditorToolbar } from 'src/app/core/framework/input-components/html-editor/html-editor-toolbar';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { FormComponent } from 'src/app/core/wireframes/app.form.component';
import { PoliticaDePrivacidade } from '../model/politica-de-privacidade.model';
import { PoliticaDePrivacidadeService } from '../politica-de-privacidade.service';


@Component({
  selector: 'app-politica-de-privacidade-form',
  templateUrl: './politica-de-privacidade-form.component.html',
  styleUrls: ['./politica-de-privacidade-form.component.css']
})
export class PoliticaDePrivacidadeFormComponent extends FormComponent implements OnInit, OnDestroy {

  politica = new PoliticaDePrivacidade();
  private context = this;

  editor: Editor;
  toolbar: Toolbar = HtmlEditorToolbar.default;  

  constructor(
      private route: ActivatedRoute
      , private router: Router
      , private breadcrumbService: BreadcrumbService
      , private toasterService: ToasterService
      , private location: Location
      , private politicaDePrivacidadeService: PoliticaDePrivacidadeService
  ) {
      super();
  }

  ngOnInit(): void {
    this.breadcrumbService.setItems([
      {label: 'Segurança'}, {label: 'Política de privacidade', routerLink: ['/seguranca/politica-de-privacidade-lista']}
   ]);

    this.route.params.subscribe( params => {
        this.pId = params['id'];

        this.breadcrumbService.setMenuConfig(
            this.breadcrumbService.getOrCreateMenuConfig()
                .setContext(this.context)
                .setShowExcluir(this.pId > 0)
                .setShowNovo(false)
        );

        if (this.pId > 0) {
            this.politicaDePrivacidadeService.fetch(this.pId)
            .subscribe(politica => {
                this.politica = politica;
            });
        }
    });    

    this.editor = new Editor();
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  atualizar() {
    this.politicaDePrivacidadeService.atualizar(this.pId, this.politica)
        .subscribe(() => {
            this.toasterService.success();
        });
  }

  inserir() {
      this.politicaDePrivacidadeService.inserir(this.politica)
          .subscribe(inventario => {
              this.pId = inventario.id;
              this.toasterService.success();
              this.location.back();
          });
      }

  excluir() {
      this.politicaDePrivacidadeService.excluir(this.pId)
          .subscribe(() => {
              this.toasterService.success();
              this.location.back();
          });
  }

}
